import React from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { BsXLg } from "react-icons/bs";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import OverlayLoader from "./OverlayLoader";

const Modaljs = ({
  open,
  close,
  children,
  size,
  Savebtn,
  saveOnclick,
  className,
  closebtn,
  title,
  newButtonTitle,
  newButtonOnclick,
  newButtonType,
  hideFooter,
  footerClass,
  newButtonClass,
  formikProps,
  dialogClassName,
  px = 3,
  // Formik callers get the busy state for free from isSubmitting. Modals driven
  // by plain state (the attendance ones) had no way to say "a request is in
  // flight", so their save button stayed live and could be clicked twice.
  busy = false,
  // Shown over the body while the modal is still fetching what it needs.
  loading = false,
}) => {
  const { t } = useTranslation();
  const isBusy = busy || formikProps?.isSubmitting;
  return (
    <Modal
      size={size}
      show={open}
      onHide={close}
      dialogClassName={dialogClassName}
      scrollable={true}
      backdrop="static"
      centered
      className="my-modal modal-area"
    >
      {/* table-bg border-4 modal-animate border-orange border-bottom py-2 m-3 */}
      <Form onSubmit={formikProps?.handleSubmit} className="d-content">
        <Modal.Header className="table-bg border-4 border-orange border-bottom py-2 m-3">
          <strong>{title}</strong>
          {/* Closing mid-save would hide the dialog without stopping the
              request, so the cross goes quiet until it comes back. */}
          <div
            onClick={isBusy ? undefined : close}
            className="nav-link ms-auto cursor-pointer"
            style={isBusy ? { opacity: 0.4, cursor: "not-allowed" } : undefined}
          >
            <BsXLg />
          </div>
        </Modal.Header>
        <Modal.Body className="pt-0" style={{ position: "relative" }}>
          {loading && <OverlayLoader />}
          <SimpleBar className={`area px-${px}`}>{children}</SimpleBar>
        </Modal.Body>
        {!hideFooter && (
          <Modal.Footer className={`table-bg py-1 gap-2 ${footerClass}`}>
            <Form.Control
              size="lg"
              type="text"
              className={`dnone ${className}`}
              placeholder="Type your comments..."
            />
            <Button
              className="bg-new text-uppercase text-gray"
              onClick={close}
              disabled={isBusy}
            >
              {t(closebtn)}
            </Button>
            <div className="vr hr-shadow" />
            <Button
              onClick={saveOnclick}
              variant="primary"
              type="submit"
              className="bg-new text-uppercase text-secondary"
              disabled={isBusy}
            >
              {isBusy ? (
                <>
                  <Spinner animation="border" variant="primary" size="sm" />{" "}
                  PLEASE WAIT...
                </>
              ) : (
                <>{t(Savebtn)}</>
              )}
            </Button>
            {newButtonTitle && (
              <>
                <div className="vr hr-shadow" />
                <Button
                  type={newButtonType}
                  className={`bg-new text-uppercase text-gray ${newButtonClass}`}
                  onClick={newButtonOnclick}
                >
                  {newButtonTitle}
                </Button>
              </>
            )}
          </Modal.Footer>
        )}
      </Form>
    </Modal>
  );
};

export default Modaljs;
